import { render } from "./account-info.html?vue&type=template&id=f4e01496&scoped=true&ts=true"
import script from "./account-info.vue?vue&type=script&lang=ts"
export * from "./account-info.vue?vue&type=script&lang=ts"

import "./account-info.scss?vue&type=style&index=0&id=f4e01496&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4e01496"]])

export default __exports__